export enum GraphQLEndpoints {
  CGS = 'cgs',
  TOSA = 'tosa',
  AUTH = 'auth',
}
